import { dmeConfig } from "dmeditor";
import { DME, DMEData } from "dmeditor";
import { nanoid } from "nanoid";
import { EntityBridgeSpill } from "./entity";

export const definition: DME.Widget = {
  category: "bridge",
  icon: "bridge",
  name: "Bridge Spill",
  type: "bridge-spill",
  widgetType: "widget",
  events: {
    createBlock: (): DMEData.Block<EntityBridgeSpill> => {
      return {
        id: nanoid(),
        type: "bridge-spill",
        data: {
          new: true,
          inputData: {
            giver: "n",
            zone: "i",
            boardNo: "",
            north: {
              spade: { data: "" },
              heart: { data: "" },
              diamond: { data: "" },
              club: { data: "" },
            },
            south: {
              spade: { data: "" },
              heart: { data: "" },
              diamond: { data: "" },
              club: { data: "" },
            },
            east: {
              spade: { data: "" },
              heart: { data: "" },
              diamond: { data: "" },
              club: { data: "" },
            },
            west: {
              spade: { data: "" },
              heart: { data: "" },
              diamond: { data: "" },
              club: { data: "" },
            },
            question: [{ type: "paragrah", children: [{ text: "" }] }],
            answer: [{ type: "paragrah", children: [{ text: "" }] }],
            bidding: {
              list: ["", "", "", "", "", "", "", ""],
              description: [{ type: "paragrah", children: [{ text: "" }] }],
            },
          },
          settings: {
            general: {
              padding: 10,
              align: "center",
            },
          },
        },
      };
    },
  },
  settings: [],
};
